<app-radio [(ngModel)]="selectedValue" (ngModelChange)="onModelChange()" [inline]="inline" [disabled]="disabled"
             [options]="[true, false]" [formatter]="formatter" [id]="id" [required]="required"></app-radio>
